// React
import React, { useMemo } from 'react';

// Styles
import styles from './style.module.scss';

type SlotTrackingProps = {
  currentSlot: number;
  totalSlots: number;
  classes?: {
    root?: string;
    slot?: string;
  };
}

const SlotTracking: React.FC<SlotTrackingProps> = ({ currentSlot, totalSlots, classes }) => {

  const slots = useMemo(() => {
    return Array.from({ length: totalSlots }, (_, index) => ({ key: crypto.randomUUID(), index: index }));
  }, [totalSlots]);

  return (
    <div className={`${styles.root} ${classes?.root}`}>
      {slots.map((slot) => {
        const isActive = slot.index <= currentSlot;

        return (
          <div key={slot.key} className={`${styles.slot} ${isActive ? styles.active : ''} ${classes?.slot}`} />
        )
      })}
    </div>
  )
}

export default SlotTracking;
